import axios from "../components/AxiosCustomInstance";
import moment from "moment";

const api_prefix = `${process.env.REACT_APP_API_URL}/api`;

export const getGroupCdList = async () => {
  const resp = await axios
    .get(`${api_prefix}/chart-groupCd`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return resp;
};

export const getAllMedia = async () => {
  const resp = await axios
    .get(`${api_prefix}/chart-analysis/allmedia`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return resp;
};

export const registerAccount = async (data) => {
  const resp = await axios
    .post(`${api_prefix}/chart/add`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return resp;
};
export const getChartAccountList = async (params) => {
  let expireParam = "";
  if (params.expireAt) {
    const fromDate = new Date(
      params.expireAt.getFullYear(),
      params.expireAt.getMonth(),
      1
    );
    const toDate = new Date(
      params.expireAt.getFullYear(),
      params.expireAt.getMonth() + 1,
      0
    );
    const from = moment(fromDate).format("YYYY/MM/DD");
    const to = moment(toDate).format("YYYY/MM/DD");
    expireParam = encodeURI(`&expire_at_before=${to}&expire_at_after=${from}`);
  }

  const resp = await axios
    .get(`${api_prefix}/chart?text=${encodeURIComponent(params.text)}${expireParam}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return resp;
};

export const getAccount = async (userId) => {
  const resp = await axios
    .get(`${api_prefix}/chart/${userId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return resp;
};
export const updateAccount = async (userId, data) => {
  const resp = await axios
    .put(`${api_prefix}/chart/${userId}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return resp;
};

export const getChartMediaList = async (text) => {
  const resp = await axios
    .get(`${api_prefix}/chart-analysis/list?text=${encodeURIComponent(text)}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return resp;
};

export const getChartMedia = async (id) => {
  const resp = await axios
    .get(`${api_prefix}/chart-analysis/item/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return resp;
};
export const updateChartMedia = async (id, data) => {
  const resp = await axios
    .put(`${api_prefix}/chart-analysis/item/${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return resp;
};
export const createMaster = async (data) => {
  const resp = await axios
    .post(`${api_prefix}/chart-analysis`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return resp;
};
export const getLogDownload = async (params) => {
  const from = moment(params.startDate);
  const to = moment(params.endDate);
  const query = [
    `name=${encodeURIComponent(params.search || "")}`,
    `start=${encodeURIComponent(from.format("YYYY/MM/DD"))}`,
    `end=${encodeURIComponent(to.format("YYYY/MM/DD"))}`,
  ].join("&");
  const resp = await axios
    .get(`${api_prefix}/chart-log/download?${query}`, {
      responseType: "blob",
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return resp;
};
